import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
//import { useLanguage } from './../../../utilities/LanguageContext'

//Componentes comunes generales
// import { Header } from './../../Header/Header'
import { Header } from './../../Header/V2/Header'
import { Loading } from './../../Common/Loading'
import { LogErrors } from './../../../utilities/LogErrors'
import { ValidateSession } from './../../../utilities/BL/Sessions'
import { GoToTop } from './../../Common/GoToTop'
import { GoToBack } from './../../Common/GoToBack'
//import { GetDataFromTheChosenCourse } from "../../utilities/BL/Student/Courses"

import { CourseData } from './../CourseData'
import { SaveResultItemToShow } from './../../../utilities/BL/Navigation'
import { Credits } from './../../Common/Credits/Credits'
import { FormatDateTime } from './../../../utilities/BL/Instructor/Results'

//Funciones personalizadas del proyecto
//import { GetExamResult } from './../../../utilities/BL/Students'
//import { QuestionDrafting } from './../QuestionDrafting'
import { HELP_TYPE } from './../../../utilities/EL/HelpType'
import { WEBPAGES } from './../../../utilities/EL/WebPages'
import { TYPE_PROPOSITION_VALUE } from './../../../utilities/EL/TypePropositionValue'
import { ROLES } from './../../../utilities/EL/Roles'
import { BodyWithSideMenu } from './../../Dashboard/BodyWithSideMenu'

//Agregar multiidioma


const Results = () => {
    //const { translate } = useLanguage() // Obtén la función de traducción desde el contexto
    const navigate = useNavigate()

    const [session, setSession] = useState({})
    const [theme, setTheme] = useState(null)

    const [isLoading, setIsLoading] = useState(true)
    const [evaluations, setEvaluations] = useState(null)


    const GoToResultItem = async (evaluationIndex) => {
        try {
            //Guardar el item del resultado a mostrar
            const response = await SaveResultItemToShow(session, evaluationIndex) //evaluation.idItem
            
            if (response.success) {
                navigate('/results/items')
            } else {
                console.log(response.message)
            }
        } catch (error) {
            await LogErrors('GoToResultItem - Results', error)
        }
    }
    
    const LoadPage = async (sessionInfo) => {
        try {
            setTheme(sessionInfo.user.userTheme)

            document.body.classList.add('BodyComplete')

            
            if (sessionInfo.evaluations !== undefined && sessionInfo.evaluations !== null) {
                const evaluations = sessionInfo.evaluations.filter(evaluation => evaluation.idCourse === sessionInfo.navigation.result.course)
                
                if (evaluations) {
                    setEvaluations(evaluations)
                }
            }
        } catch (error) {
            await LogErrors('LoadPage - Results', error)
        } finally {
            setIsLoading(false)
        }
    }

    /**
     * Función para obtener la configuración, una vez que termine de cargarse el componente
     */
    useEffect(() => {
        async function Validate() {
            const tmpSession = await ValidateSession()
            setSession(tmpSession.data)
            
            if (tmpSession.success) {
                if (tmpSession.data.user.userStatus === 2) {
                    await LoadPage(tmpSession.data)
                } else {
                    navigate('/confirm')
                }
            } else {
                navigate(`/?logout=${process.env.REACT_APP_LOGOUT_PARAMETER}`)
            }
        }
        Validate()
    }, []) // El array vacío [] asegura que useEffect se ejecute solo una vez, al montar
    

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <>
                    <BodyWithSideMenu page={WEBPAGES.ZTUDENT.RESULTS} theme={theme} propositionValue={TYPE_PROPOSITION_VALUE.ZTUDENT} idHelp={HELP_TYPE.ZTUDENT.RESULTS} role={ROLES.ZTUDENT}>
                        {/* <Header theme={theme} idHelp={HELP_TYPE.ZTUDENT.RESULTS} /> */}
                        <Header theme={theme} setTheme={setTheme} propositionValue={TYPE_PROPOSITION_VALUE.ZTUDENT} idHelp={HELP_TYPE.ZTUDENT.RESULTS} />
                        
                        <main className='container Items Container-FullHeight'>
                            <GoToBack url={'/dashboard'} />

                            {evaluations ? (
                                <>
                                    {evaluations.length === 0 ? (
                                        <p>Aún no tienes resultados.</p>
                                    ) : (
                                        <>
                                            {/* <p className='Items__Course'>Curso: Hojas de cálculo</p> */}
                                            <p className='Items__Title'>Resultados por evaluación</p>
                                            <CourseData idEvaluation={session.navigation.result.course} className='Items__Course' />

                                            {/* SearchInput */}

                                            <ol className='Items__Items'>
                                                {evaluations.map((evaluation, index) => (
                                                    <li key={index} className={`Items__Items__Item ${evaluation?.reviewcompleted && evaluation?.score ? evaluation.score >= 800 ? 'Items__Items__Item--Success' : 'Items__Items__Item--Danger' : ''} Tables--Shadow`} onClick={() => GoToResultItem(index)}>
                                                        {evaluation?.lastRequest && (
                                                            <span className='text-center small mb-3'>Fecha y hora: {FormatDateTime(evaluation.lastRequest)}</span>
                                                        )}

                                                        <span className='Items__Items__Item__Name'>
                                                            <span className='Items__Items__Item__Name__Text'>{evaluation?.name ? evaluation.name : 'No ha sido posible obtener el nombre de la evaluación'}</span>
                                                        </span>

                                                        {evaluation?.reviewcompleted ? (
                                                            evaluation?.score ? (
                                                                <span className='text-center'>Resultado: {evaluation?.score ? evaluation.score === 1000 ? '1,000' : evaluation.score : ''} puntos</span>
                                                            ) : (
                                                                <span className='text-center'>No ha sido posible obtener tu resultado en este momento.</span>
                                                            )
                                                        ) : (
                                                            <span className='text-center'>La mente maestra está revisando tu evaluación en nuestro laboratorio. Consulta tu resultado más tarde.</span>
                                                        )}

                                                        <button type='button' className='Items__Items__Item__Button' onClick={() => GoToResultItem(index)}>Ver resultado</button>
                                                    </li>
                                                ))}
                                            </ol>
                                        </>
                                    )}
                                </>
                            ) : (
                                <p>No se pudieron obtener los resultados de tus evaluaciones. Inténtalo nuevamente o más tarde.</p>
                            )}
                        </main>
                    </BodyWithSideMenu>
                </>
            )}
        </>
    )
}

export { Results };